import ApiInstance from "../configs/ApiInstance";

async function DeleteNotification(nickname, notificationId) {
    await ApiInstance.userService.delete(`${nickname}/notifications/${notificationId}`);
}

export default DeleteNotification;